import React from 'react';

import Connect from './connect';
import Disconnect from './disconnect';
import NylasGrant from './index';
import Status from './status';
import gmailIcon from 'assets/images/logos/gmail.svg';
import googleIcon from 'assets/images/logos/google.svg';

import type { GrantProps } from './types';

export function GoogleGrant({ grant, paths, onDestroy }: GrantProps) {
  const canConnect = !grant || grant.expired;

  return (
    <NylasGrant
      icon={gmailIcon}
      label="Gmail"
      status={grant && <Status grant={grant} />}
    >
      {canConnect &&
        <Connect
          grant={grant}
          icon={googleIcon}
          label="Google"
          path={paths.auth}
          providerName="google"
          scopes={['https://www.googleapis.com/auth/gmail.readonly']}
        />
      }

      {grant &&
        <Disconnect
          destroyPath={paths.destroy}
          variant={canConnect ? 'danger' : 'ghost'}
          onDestroy={onDestroy}
        />
      }
    </NylasGrant>
  );
}
